(() => {
  const format = value => new Intl.NumberFormat('sv-SE', {minimumFractionDigits: Number.isInteger(value) ? 0 : 2, maximumFractionDigits: 2}).format(value);
  const parse = raw => {
    let value = raw.replace(/\s/g, '');
    const comma = value.lastIndexOf(','), dot = value.lastIndexOf('.');
    if (comma >= 0 && dot >= 0) value = comma > dot ? value.replace(/\./g, '').replace(',', '.') : value.replace(/,/g, '');
    else if (comma >= 0) value = /^\d{1,3}(,\d{3})+$/.test(value) ? value.replace(/,/g, '') : value.replace(',', '.');
    else if (dot >= 0 && /^\d{1,3}(\.\d{3})+$/.test(value)) value = value.replace(/\./g, '');
    return Number(value);
  };
  const normalize = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement || node.parentElement.closest('script,style,textarea,input,select,code,pre')) continue;
      if (!/kr|SEK/.test(node.nodeValue)) continue;
      const text = node.nodeValue.replace(/(\d[\d \u00a0\u202f.,]*?)\s*(kr|SEK)\b/g, (match, raw, unit) => {
        const value = parse(raw);
        return Number.isFinite(value) ? format(value) + ' ' + unit : match;
      });
      if (node.nodeValue !== text) node.nodeValue = text;
    }
  };
  const start = () => {
    normalize(document.body);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; normalize(document.body); });
    }).observe(document.body, {childList: true, characterData: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();